<template>
  <div class="preview">
    <div class="toolbox">
      <div class="shiying" @click="shiying()"></div>
      <div class="expend" @click="zoomTo(0.1)"></div>
      <div class="increase" @click="zoomTo(-0.1)"></div>
      <div class="value" @click="back">{{ parseFloat(zoom * 100).toFixed(0) }}%</div>
    </div>
    <div class="close" @click="close"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      oldzoom: 1,
      zoom: 1
    }
  },
  methods: {
    shiying() {
      this.zoom = this.oldzoom
      window.viewer.zoomTo(this.oldzoom)
    },
    back() {
      this.zoom = 1
      window.viewer.zoomTo(1)
    },
    zoomTo(val) {
      let {zoom} = this
      this.zoom = parseFloat(+zoom + val).toFixed(2)
      if (this.zoom < 0.1) {
        this.zoom = 0.1
      }
      console.log(this.zoom)
      window.viewer.zoomTo(this.zoom)
    },
    close() {
      this.$parent.showPreview = false
      window.viewer.hide()
    }
  },
  mounted() {
    this.$Bus.$on('zoom', ratio => {
      this.zoom = ratio
    })
  }
}
</script>
<style lang="less" scoped>
.preview {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99999;
  .img-box {
    width: 474px;
    margin: 33px auto;
    img {
      width: 100%;
    }
  }
  .toolbox {
    width: 180px;
    height: 40px;
    position: fixed;
    background: rgba(238, 246, 255, 0.45);
    border-radius: 8px;
    left: 50%;
    bottom: 32px;
    transform: translate(-50%, 0);
    display: flex;
    justify-content: space-around;
    align-items: center;
    .shiying {
      width: 40px;
      height: 40px;
      background: url(~@/assets/images/full.svg) no-repeat 100% 100%;
      cursor: pointer;
      background-position: center;
      position: relative;
      left: -1px;
      &:hover {
        background-color: #eef6ff;
        border-radius: 8px;
      }
      &:hover::after {
        display: block !important;
      }
      &::after {
        content: '适应窗口';
        position: absolute;
        padding: 6px 12px;
        background: #000000;
        border-radius: 8px;
        top: -40px;
        text-align: center;
        color: #ffffff;
        left: -21px;
        display: none;
        width: max-content;
      }
    }
    .expend {
      width: 40px;
      height: 40px;
      background: url(~@/assets/images/dark_expend.svg) no-repeat 100% 100%;
      background-position: center;
      cursor: pointer;
      &:hover {
        background-color: #eef6ff;
        border-radius: 8px;
      }
      &:hover::after {
        display: block !important;
      }
      &::after {
        content: '放大';
        position: absolute;
        padding: 6px 12px;
        background: #000000;
        border-radius: 8px;
        top: -40px;
        text-align: center;
        color: #ffffff;
        left: 37px;
        display: none;
      }
    }
    .increase {
      width: 40px;
      height: 40px;
      background: url(~@/assets/images/dark_increase.svg) no-repeat 100% 100%;
      cursor: pointer;
      background-position: center;
      &:hover {
        background-color: #eef6ff;
        border-radius: 8px;
      }
      &:hover::after {
        display: block !important;
      }
      &::after {
        content: '缩小';
        position: absolute;
        padding: 6px 12px;
        background: #000000;
        border-radius: 8px;
        top: -40px;
        text-align: center;
        color: #ffffff;
        left: 80px;
        display: none;
      }
    }
    .value {
      width: 36px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-family: ArialMT;
      font-size: 14px;
      color: #19192b;
      letter-spacing: 0;
      font-weight: 400;
      margin-right: 8px;
      cursor: pointer;
    }
  }
  .close {
    position: fixed;
    width: 48px;
    height: 48px;
    background: url(~@/assets/images/close_white.svg) no-repeat center center rgba(247, 251, 255, 0.3);
    background-size: 16px 16px;
    border-radius: 50%;
    top: 32px;
    right: 32px;

    &:hover {
      background-size: 16px 16px;
      background: url(~@/assets/images/close_white.svg) no-repeat center center;
      background-color: rgba(247, 251, 255, 0.2);
    }
  }
}
</style>
